import { round } from 'lodash';

export default round;
